import React from "react";
import styled from 'styled-components'


const BackgroundWrapper = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: ${props => props.color};
`

function Background(props) {

    let backgroundColor = props.content.backgroundColor || 'transparent'
    let backgroundImage = (props.content.backgroundImage) ? props.content.backgroundImage.fields.file.url : 'none';
    return(
        <BackgroundWrapper image={backgroundImage} color={backgroundColor}></BackgroundWrapper>
    )
}

export default Background;